import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('INSURANCE_NETWORK_AGGREGATED')